module.exports = __webpack_public_path__ + "static/media/access-signup-background.bf77e13a.jpeg";